import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import FeedbackWidget from "./FeedbackWidget";
import QuickPinButton from "./QuickPinButton";

const AppLayout = () => (
  <div className="main-wrapper">
    <Header />
    <Sidebar />
    <Outlet />
    <FeedbackWidget />
    <QuickPinButton />
  </div>
);

export default AppLayout;
